import {
  deleteRequest,
  getRequestWithoutAuth,
  postRequest,
  postRequestWithoutAuth,
  postRequestWithProvidedHeader,
} from "../../globalhelper/helper";
import { NAVURL } from "../Common/commonActionTypes";
import {
  INITIATE_LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  REQUEST_CURRENT_STATE,
  SAVE_TOKEN,
  SET_NEW_TOKEN,
} from "./loginActionTypes";
import { showLoader, hideLoader } from "../Common/commonActions";

export function requestCurrentState() {
  return (dispatch) => {
    dispatch({
      type: REQUEST_CURRENT_STATE,
    });
  };
}

export const SetNewToken = (new_token) => {
  return (dispatch) => {
    dispatch({
      type: SET_NEW_TOKEN,
      payload: new_token
    })
  }
}

export function onLogout() {
  return (dispatch) => {
    // dispatch(flushCommonObject());
    dispatch({
      type: LOGOUT
    })
  }
}

export function loginSuccess(data) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_SUCCESS,
      payload: data,
    });
  };
}

function saveToken(data) {
  return (dispatch) => {
    dispatch({
      type: SAVE_TOKEN,
      forgetPasswordToken: data,
    });
  };
}

export function logout() {
  return (dispatch) => {
    return deleteRequest("api/auth/logout").then(() => {
      dispatch({
        type: LOGOUT,
      });
    });
  };
}

export function login(formData) {
  return (dispatch) => {
    console.log("On Login");
    dispatch(showLoader());
    dispatch(requestCurrentState());
    return postRequest("api/auth/getUserProfile", formData)
      .then((data) => {
        dispatch(hideLoader());
        if (data.type === "success") {
          localStorage.setItem("go_to_landing_page", "1");
          localStorage.setItem("organization", data.res.data.USR_Organization);
          dispatch(loginSuccess(data.res.data));
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        console.log(error);
      });
  };
}

export function changePassword(formData, header) {
  return (dispatch) => {
    dispatch(requestCurrentState());
    return changePass(formData, header).then((data) => {
      if (data.type === "success") {
        // dispatch(onSuccessChange(data.res.data))
      }
    });
  };
}

export function onRequestPassword(email) {
  return (dispatch) => {
    dispatch(requestCurrentState());
    return requestOtp(email).then((data) => {
      if (data.type === "success") {
        dispatch(saveToken(data.res.data));
      }
    });
  };
}

export function initiateLogin(data) {
  return (dispatch) => {
    dispatch({
      type: INITIATE_LOGIN,
      data,
    });
  };
}

export function verifyLogin() {
  return (dispatch) => {
    getRequestWithoutAuth("api/auth/verifyLogin").then(({ res }) => {
      if (res?.status === "success") {
        dispatch(loginSuccess(res.data));
      } else {
        dispatch(
          initiateLogin({
            user: {
              login: false,
            },
            alert: null,
          })
        );
      }
    });
  };
}

const requestOtp = async (email) => {
  var d = postRequestWithoutAuth("api/auth/passwordReset", {
    email: email,
  });
  return d;
};

const changePass = async (formData, header) => {
  var d = postRequestWithProvidedHeader(
    "api/auth/changePass",
    formData,
    header
  );
  return d;
};
